import { imageUrlForKey } from "../stitch-bind";
import { formatPriceCop } from "../price-format";
import { buildWhatsAppProductUrl } from "../whatsapp";
import { siteConfig } from "../config/site";
import { bindProductGallery } from "../product-gallery";
import { getProductBySlug, productGalleryImageKeys } from "../content/products";
import { getCollectionBySlug } from "../content/collections";
import { categoryLabelEs, getProductSpecRows } from "../content/spec-rows";

export function renderProductoPage(): void {
  const mount = document.querySelector("[data-product-mount]");
  if (!(mount instanceof HTMLElement)) return;

  const slug = new URLSearchParams(window.location.search).get("p");
  mount.textContent = "";

  if (slug === null || slug === "") {
    const p = document.createElement("p");
    p.className = "product-missing";
    p.textContent = "Indica un producto en la URL, por ejemplo: /producto.html?p=camiseta-shogun-tech";
    mount.appendChild(p);
    return;
  }

  const product = getProductBySlug(slug);
  if (product === undefined) {
    const p = document.createElement("p");
    p.className = "product-missing";
    p.textContent = "No encontramos ese producto. Revisa el catálogo.";
    const a = document.createElement("a");
    a.href = "/catalogo.html";
    a.className = "link-secondary-ghost";
    a.textContent = "Ir al catálogo";
    mount.appendChild(p);
    mount.appendChild(a);
    return;
  }

  const collection = getCollectionBySlug(product.collectionId);

  const wrap = document.createElement("div");
  wrap.className = "product-dynamic";

  const breadcrumb = document.createElement("nav");
  breadcrumb.className = "breadcrumb";
  breadcrumb.setAttribute("aria-label", "Ruta");
  breadcrumb.innerHTML = `<a href="/">Inicio</a><span class="breadcrumb__sep" aria-hidden="true">/</span><a href="/catalogo.html">Catálogo</a><span class="breadcrumb__sep" aria-hidden="true">/</span><span>${product.name}</span>`;

  const article = document.createElement("article");
  article.className = "product-detail product-detail--dynamic";

  const galleryKeys = productGalleryImageKeys(product);
  let gallery: HTMLElement;

  if (galleryKeys.length > 1) {
    gallery = document.createElement("div");
    gallery.className = "product-detail__gallery product-detail__gallery--stitch";
    gallery.dataset.productGallery = "";

    const thumbsRow = document.createElement("div");
    thumbsRow.className = "product-detail__thumbs product-detail__thumbs--vertical";
    thumbsRow.setAttribute("role", "tablist");
    thumbsRow.setAttribute("aria-label", "Vistas del producto");

    const heroWrap = document.createElement("div");
    heroWrap.className = "product-detail__hero-wrap";

    const mainImg = document.createElement("img");
    mainImg.src = imageUrlForKey(galleryKeys[0]);
    mainImg.alt = product.name;
    mainImg.width = 1200;
    mainImg.height = 1500;
    mainImg.decoding = "async";
    mainImg.dataset.galleryMain = "";
    heroWrap.appendChild(mainImg);

    galleryKeys.forEach((key, index) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "product-detail__thumb";
      if (index === 0) btn.classList.add("product-detail__thumb--active");
      btn.dataset.galleryThumb = "";
      btn.setAttribute(
        "aria-label",
        `Vista ${String(index + 1)} de ${String(galleryKeys.length)}`,
      );
      const thumbImg = document.createElement("img");
      thumbImg.src = imageUrlForKey(key);
      thumbImg.alt =
        index === 0 ? product.name : `${product.name} — vista ${String(index + 1)}`;
      thumbImg.loading = "lazy";
      thumbImg.decoding = "async";
      btn.appendChild(thumbImg);
      thumbsRow.appendChild(btn);
    });

    gallery.appendChild(thumbsRow);
    gallery.appendChild(heroWrap);
    bindProductGallery(gallery);
  } else {
    gallery = document.createElement("div");
    gallery.className = "product-detail__hero-wrap product-detail__hero-wrap--solo";
    const heroImg = document.createElement("img");
    heroImg.src = imageUrlForKey(galleryKeys[0]);
    heroImg.alt = product.name;
    heroImg.width = 1200;
    heroImg.height = 1500;
    heroImg.decoding = "async";
    gallery.appendChild(heroImg);
  }

  const aside = document.createElement("div");

  const catBadge = document.createElement("span");
  catBadge.className = "product-detail__badge";
  catBadge.textContent = categoryLabelEs(product.category);

  const h1 = document.createElement("h1");
  h1.className = "product-detail__title";
  h1.textContent = product.name;

  const price = document.createElement("p");
  price.className = "product-detail__price";
  price.textContent = formatPriceCop(product.priceCop);

  const sku = document.createElement("p");
  sku.className = "product-detail__sku";
  sku.textContent = `SKU ${product.sku}`;

  const edition = document.createElement("p");
  edition.className = "product-detail__edition";
  edition.textContent =
    product.editionNote ??
    `En Hikarai hacemos máximo ${String(siteConfig.maxPrintsPerDesign)} unidades de este tipo de producto con el mismo diseño.`;

  const desc = document.createElement("p");
  desc.className = "product-detail__copy";
  desc.textContent = product.shortDescription;

  if (collection) {
    const colLink = document.createElement("p");
    colLink.className = "product-detail__collection";
    const a = document.createElement("a");
    a.href = collection.href;
    a.textContent = `Colección: ${collection.name}`;
    colLink.appendChild(a);
    aside.appendChild(colLink);
  }

  const specTitle = document.createElement("h2");
  specTitle.className = "product-specs__title";
  specTitle.textContent = "Especificaciones";

  const dl = document.createElement("dl");
  dl.className = "product-specs";
  for (const row of getProductSpecRows(product)) {
    const dt = document.createElement("dt");
    dt.textContent = row.label;
    const dd = document.createElement("dd");
    dd.textContent = row.value;
    dl.appendChild(dt);
    dl.appendChild(dd);
  }

  const actions = document.createElement("div");
  actions.className = "product-detail__actions product-detail__actions--stack";

  const buy = document.createElement("a");
  buy.href = buildWhatsAppProductUrl(product.name, formatPriceCop(product.priceCop), product.sku);
  buy.target = "_blank";
  buy.rel = "noopener noreferrer";
  buy.className = "btn btn--primary product-detail__cta-full";
  buy.textContent = "Comprar por WhatsApp";

  const ig = document.createElement("a");
  ig.href = siteConfig.contact.instagramUrl;
  ig.target = "_blank";
  ig.rel = "noopener noreferrer";
  ig.className = "btn btn--secondary";
  ig.textContent = `Ver @${siteConfig.contact.instagramHandle}`;

  actions.appendChild(buy);
  actions.appendChild(ig);

  aside.appendChild(catBadge);
  aside.appendChild(h1);
  aside.appendChild(price);
  aside.appendChild(sku);
  aside.appendChild(edition);
  aside.appendChild(desc);
  aside.appendChild(specTitle);
  aside.appendChild(dl);
  aside.appendChild(actions);

  article.appendChild(gallery);
  article.appendChild(aside);

  wrap.appendChild(breadcrumb);
  wrap.appendChild(article);
  mount.appendChild(wrap);
}
